import { paginator } from '@/services';

export default {
  SET_CONTAINERS(state, payload) {
    if (payload) {
      state.containers = payload;
    } else {
      state.containers = paginator()();
    }
  },
  SET_CONTAINER_SELECIONADO(state, payload) {
    state.containerSelecionado = payload;
  },
  SET_DETALHES(state, payload) {
    if (Array.isArray(payload)) {
      state.detalhes = payload;
    } else {
      state.detalhes = [];
    }
  },
};
